import { SyncConfigTypes } from './actionTypes';

const INIT_STATE = {
  listData: [],
  error: '',
  errorCount: 0,
  CountItems: 0,
  filterItems: [],
  loading: false,
};

const SyncConfiguration = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case SyncConfigTypes.GET_SYNC_OPERATIONS:
      return { ...state, loading: true };

    case SyncConfigTypes.GET_SYNC_OPERATIONS_SUCCESS:
      return {
        ...state,
        listData: action.payload.listData,
        CountItems: action.payload.CountItems,
        filterItems: action.payload.filterItems,
        loading: false,
      };

    case SyncConfigTypes.GET_SYNC_OPERATIONS_FAIL:
      return {
        ...state,
        error: action.payload,
        listData: [],
        loading: false,
      };

    case SyncConfigTypes.ADD_SYNC_OPERATIONS:
      return {
        ...state,
        loading: false,
      };
    case SyncConfigTypes.ADD_SYNC_OPERATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SyncConfigTypes.ADD_SYNC_OPERATIONS_FAIL:
      return {
        ...state,
        error: action.payload,
        errorCount: state.errorCount + 1,
        loading: false,
      };
    case SyncConfigTypes.UPDATE_SYNC_OPERATIONS:
      return {
        ...state,
        loading: false,
      };
    case SyncConfigTypes.DELETE_SYNC_OPERATIONS:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default SyncConfiguration;
